<div class="confirm-modal ig-modal toggle-features-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div style="max-height: 90vh;overflow-y: auto">
        <div class="title">Turn On/Off Features</div>
        <p>{{ account.account.userName }}:</p>
        <ig-spinner *ngIf="loading"></ig-spinner>
        <ng-container *ngIf="!loading">
            <ig-row>
                <ig-col [xs]="6" [md]="6">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.itinerary" (change)="toggleItinerary()">
                        <ig-success-wrap #itinerarySuccess [delay]="500" [hideAfter]="2000">
                            Itinerary {{ features.itinerary ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
                <ig-col [xs]="6" [md]="5">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.tripPlanner" (change)="toggleTripPlanner()">
                        <ig-success-wrap #tripPlannerSuccess [delay]="500" [hideAfter]="2000">
                            Trip Planner {{ features.tripPlanner ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
            </ig-row>
            <ig-row>
                <!-- <ig-col [xs]="12" [md]="6">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.tripPlanner" (change)="toggleTripPlanner()">
                        <ig-success-wrap #tripPlannerSuccess [delay]="500" [hideAfter]="2000">
                            Trip Planner {{features.tripPlanner ? '(On)' : '(Off)'}}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col> -->
                <ig-col [xs]="12" [md]="6">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.placeCalendar"
                                      (change)="togglePlaceCalendar()">
                        <ig-success-wrap #placeCalendarSuccess [delay]="500" [hideAfter]="2000">
                            Places {{ features.placeCalendar ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
                <ig-col [xs]="12" [md]="5">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.googleReviews"
                                      (change)="toggleGoogleReviews()">
                        <ig-success-wrap #googleReviewsSuccess [delay]="500" [hideAfter]="2000">
                            Google Place Reviews {{ features.googleReviews ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12" [md]="6">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.manualEvents"
                                      (change)="toggleManualEvents()">
                        <ig-success-wrap #manualEventsSuccess [delay]="500" [hideAfter]="2000">
                            Manual Events {{ features.manualEvents ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
                <ig-col [xs]="12" [md]="5">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.eventByGeolocation"
                                      (change)="toggleEventByGeolocation()">
                        <ig-success-wrap #eventByGeolocationSuccess [delay]="500" [hideAfter]="2000">
                            Events by Geolocation / API {{ features.eventByGeolocation ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12" [md]="5">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.regionalAccountType"
                                      (change)="toggleRegionalAccountType()">
                        <ig-success-wrap #regionalAccountTypeSuccess [delay]="500" [hideAfter]="2000">
                            Regional Account Type {{ features.regionalAccountType ? '(On)' : '(Off)' }}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
            </ig-row>
            <ig-row>
                <!-- <ig-col [xs]="12" [md]="6">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.googleReviews"
                        (change)="toggleGoogleReviews()">
                        <ig-success-wrap #googleReviewsSuccess [delay]="500" [hideAfter]="2000">
                            Google Place Reviews (Google places) {{features.googleReviews ? '(On)' : '(Off)'}}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col> -->
                <!-- <ig-col [xs]="12" [md]="5">
                    <mat-slide-toggle *ngIf="!loading" [checked]="features.facebookPosts"
                        (change)="toggleFacebookPosts($event)">
                        <ig-success-wrap #facebookPostsSuccess [delay]="500" [hideAfter]="2000">
                            Facebook Posts (Google places) {{features.facebookPosts ? '(On)' : '(Off)'}}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col> -->
            </ig-row>
            <!-- <ig-row>
                <ig-col [xs]="12" [md]="12">
                    <mat-slide-toggle #nearbyPlaceRightToggle *ngIf="!loading" [checked]="features.nearbyPlacesRight"
                        (change)="toggleNearbyPlacesRight($event)">
                        <ig-success-wrap #nearbyPlacesRightSuccess [delay]="500" [hideAfter]="2000">
                            Move Nearby Places to the Right of the
                            Screen {{features.nearbyPlacesRight ? '(On)' : '(Off)'}}
                        </ig-success-wrap>
                    </mat-slide-toggle>
                </ig-col>
            </ig-row> -->
        </ng-container>

        <div *ngIf="!loading" class="tour-settings">
            <br>
            <div class="text-left">Itineraries</div>
            <hr>

            <div class="relative" style="text-align: left">
                <mat-checkbox [(ngModel)]="features.tour.limit.limited">Limited Itineraries
                </mat-checkbox>
                <div *ngIf="features.tour.limit.limited">
                    Itinerary limited to: {{ features.tour.limit.limitation }}
                    <mat-slider [(ngModel)]="features.tour.limit.limitation" thumbLabel tickInterval="6" step="6"
                                min="6" max="12"></mat-slider>
                    <mat-slide-toggle [(ngModel)]="features.googlePlaceGeofence">
                        Google place geofence {{ features.googlePlaceGeofence ? '(On)' : '(Off)' }}
                    </mat-slide-toggle>
                </div>

                <ig-button size="md" [isAsync]="true" (trigger)="saveTourLimitation($event)">
                    save
                </ig-button>

            </div>

        </div>

        <div>
            <br>
            <mat-tab-group>

                <mat-tab>
                    <ng-template mat-tab-label>
                        PLACES
                    </ng-template>

                    <div>
                        <mat-tab-group>
                            <mat-tab>
                                <ng-template mat-tab-label>Categories</ng-template>

                                <div class="relative">
                                    <p *ngIf="!isDefaultPlaceCategory">This client uses custom place categories, so all
                                        the default toggles
                                        here are disabled</p>
                                    <ig-row>
                                        <ig-col [xs]="12" [md]="6">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.accommodation"
                                                              (change)="togglePlaceCategory('accommodation', 0)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Accommodation {{
                                                    features.placeCategory.accommodation ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                        <ig-col [xs]="12" [md]="5">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.activity"
                                                              (change)="togglePlaceCategory('activity', 1)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Activity {{ features.placeCategory.activity ? '(On)' : '(Off)' }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>
                                    <ig-row>
                                        <ig-col [xs]="12" [md]="6">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.dining"
                                                              (change)="togglePlaceCategory('dining', 2)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Dining & Nightlife {{
                                                    features.placeCategory.dining ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                        <ig-col [xs]="12" [md]="5">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.shopping"
                                                              (change)="togglePlaceCategory('shopping', 3)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Shopping {{ features.placeCategory.shopping ? '(On)' : '(Off)' }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>
                                    <ig-row>
                                        <ig-col [xs]="12" [md]="6">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.outdoor"
                                                              (change)="togglePlaceCategory('outdoor', 4)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Outdoors {{
                                                    features.placeCategory.outdoor ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                        <ig-col [xs]="12" [md]="5">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.entertainment"
                                                              (change)="togglePlaceCategory('entertainment', 5)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Entertainment {{
                                                    features.placeCategory.entertainment ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>
                                    <ig-row>
                                        <ig-col [xs]="12" [md]="6">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.travel"
                                                              (change)="togglePlaceCategory('travel', 6)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Travel {{ features.placeCategory.travel ? '(On)' : '(Off)' }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                        <ig-col [xs]="12" [md]="5">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.art"
                                                              (change)="togglePlaceCategory('art', 7)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Art & Culture {{ features.placeCategory.art ? '(On)' : '(Off)' }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>
                                    <ig-row>
                                        <ig-col [xs]="12" [md]="6">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.other"
                                                              (change)="togglePlaceCategory('other', 8)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Other {{ features.placeCategory.other ? '(On)' : '(Off)' }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                        <ig-col [xs]="12" [md]="5">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.wellness"
                                                              (change)="togglePlaceCategory('wellness', 9)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Wellness {{
                                                    features.placeCategory.wellness ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>
                                    <ig-row>
                                        <ig-col [xs]="12">
                                            <mat-slide-toggle *ngIf="!loading" [disabled]="!isDefaultPlaceCategory"
                                                              [checked]="features.placeCategory.thingsToDo"
                                                              (change)="togglePlaceCategory('thingsToDo', 10)">
                                                <ig-success-wrap #placeCategorySuccess [delay]="500" [hideAfter]="2000">
                                                    Merge "Art & Culture, Activity, Outdoors and
                                                    Entertainment" into "Things to
                                                    Do" for Google places {{
                                                    features.placeCategory.thingsToDo ? '(On)' :
                                                      '(Off)'
                                                    }}
                                                </ig-success-wrap>
                                            </mat-slide-toggle>
                                        </ig-col>
                                    </ig-row>

                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>Client dashboard</ng-template>

                                <div class="text-left">
                                    <mat-slide-toggle *ngIf="!loading"
                                                      [checked]="features.clientDashboard.placeByGeoLocationTab"
                                                      (change)="togglePlaceClientDashboardPlaceByGeolocationTab()">
                                        <ig-success-wrap #placeByGeolocationTabSuccess [delay]="500" [hideAfter]="2000">
                                            Place by geolocation tab
                                        </ig-success-wrap>
                                    </mat-slide-toggle>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>Place widget</ng-template>

                                <div class="text-left">
                                    <div>
                                        <mat-slide-toggle *ngIf="!loading" [checked]="features.nearbyEventsInPlace"
                                                          (change)="toggleNearbyEventsInPlace()">
                                            <ig-success-wrap #nearbyEventsInPlaceSuccess [delay]="500"
                                                             [hideAfter]="2000">
                                                Nearby events in place details {{
                                                features.nearbyEventsInPlace ? '(On)' :
                                                  '(Off)'
                                                }}
                                            </ig-success-wrap>
                                        </mat-slide-toggle>
                                    </div>
                                    <div>
                                        <mat-slide-toggle *ngIf="!loading" [checked]="features.placeLocationFilter"
                                                          (change)="togglePlaceLocationFilter()">
                                            <ig-success-wrap #placeLocationFilterSuccess [delay]="500"
                                                             [hideAfter]="2000">
                                                Location filter {{ features.placeLocationFilter ? '(On)' : '(Off)' }}
                                            </ig-success-wrap>
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        EVENTS
                    </ng-template>

                    <div class="text-left">
                        <mat-slide-toggle *ngIf="!loading" [checked]="features.eventTicketUrl"
                                          (change)="toggleEventTicketUrl()">
                            <ig-success-wrap #eventTicketUrlSuccess [delay]="500" [hideAfter]="2000">
                                Show event ticket URL {{ features.eventTicketUrl ? '(On)' : '(Off)' }}
                            </ig-success-wrap>
                        </mat-slide-toggle>

                        <div class="text-left">
                            <mat-slide-toggle *ngIf="!loading" [checked]="features.nearbyPlacesInEvent"
                                              (change)="toggleNearbyPlacesInEvent()">
                                <ig-success-wrap #nearbyPlacesInEventeSuccess [delay]="500" [hideAfter]="2000">
                                    Nearby places in event details {{ features.nearbyPlacesInEvent ? '(On)' : '(Off)' }}
                                </ig-success-wrap>
                            </mat-slide-toggle>
                        </div>

                        <div>
                            <mat-slide-toggle *ngIf="!loading" [checked]="features.eventLocationFilter"
                                              (change)="toggleEventLocationFilter()">
                                <ig-success-wrap #eventLocationFilterSuccess [delay]="500" [hideAfter]="2000">
                                    Location filter {{ features.eventLocationFilter ? '(On)' : '(Off)' }}
                                </ig-success-wrap>
                            </mat-slide-toggle>
                        </div>
                    </div>

                </mat-tab>

            </mat-tab-group>


        </div>


    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/toggle.features/toggle.features.modal.component.html